import React from "react";
import { motion } from "framer-motion";
import { ReactComponent as BannerImg } from "../../../../Assets/Images/Database-image 1.svg";
import "./DatabaseBanner.css";
import "../AllBanner/technologiesBanner.css";
import { Link } from "react-router-dom";

const DatabaseBanner = () => {
  return (
    <div
      className="tech-web-banner"
      style={{
        background: " #0b4f5d",
        color: "white",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        className="d-flex flex-column flex-md-row justify-content-center align-items-center"
        style={{
          padding: "1rem 0",
          gap: "100px",
          width: "90%",
          margin: "0 auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-between align-items-center text-center"
          style={{
            flex: "1",
            maxWidth: "518px",
          }}
        >
          <h3 className="database-heading  fw-semibold text-center text-md-start mb-3">
            Databases That Do Not Collapse Under Real Use
          </h3>
          <p className="database-text small mb-4 text-center text-md-start">
            Databases rarely fail on day one. Problems begin to surface later as
            data increases, queries are slowed down, and those little shortcuts
            become daily friction. At Quad Theory Ltd, the work on databases
            begins with a knowledge of how data will be read, written and
            changed throughout a time. We design schemas, queries and storage
            choices around how people actually use things so systems remain
            fast, reliable and understandable for a long time after launch.
          </p>

          <Link className="align-self-start mx-auto mx-md-0" to="/contact-us">
            <motion.button
              type="button"
              className=" px-5 py-3  rounded-pill align-self-start mx-auto mx-md-0"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                zIndex: 5,
                position: "relative",
                fontSize: "1.4rem",
              }}
            >
              Review Your Database Setup
            </motion.button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div className="database_banner_img_section" style={{ flex: "1", textAlign: "", position: "relative" }}>
          <div className="database_banner_img"
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              background: "#0B4F5D", // Background behind SVG (important for blending)
              // display: "inline-block",
            }}
          >
            <BannerImg
              className="img-fluid  database-banner"
              style={{
                height: "100%",
                border: "0",
                mixBlendMode: "multiply", // closest to “plus darker”
                // pointerEvents: "none",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatabaseBanner;
